export default {
    directionPill: {
        long: 'DUGA',
        short: 'KRATKA',
    },
}
